import { useState } from "react";
import styles from "../CreatorsPage.module.scss";
import { Bookmark, Chevron, Comment, Heart } from "./icons";
import { img } from "./images";

/** "The flow we use ourselves": comment, DM, the guide on stippl.io, their list in the app. The green button on the third phone is live. */
const FlowDemo = () => {
	const [saved, setSaved] = useState(false);

	return (
		<section className={styles.flowsec} aria-label="The flow we use ourselves">
			<div className={styles.wrap}>
				<div className={styles.flowhead} id="flow">
					<span className={styles.eyebrow}>The flow we use ourselves</span>
					<b>
						“Comment <span className={styles.kw}>MADEIRA</span> for my hikes map”
					</b>
					<span className={styles.muted}>Tap the green button to try it.</span>
				</div>
				<div className={styles.strip} aria-label="From your post, to a DM, to the guide, to their list in Stippl">
					<div className={styles.stage}>
						<div className={styles.post} aria-hidden="true">
							<div className={styles.hd}>
								<i>
									<b>
										<img src={img("ilse-avatar.webp")} alt="" className={styles.avatarFill} />
									</b>
								</i>
								ilseandreajansen
							</div>
							<div className={styles.ph}>
								<img src={img("madeira-pol.webp")} alt="" />
								<span>5 Madeira hikes worth the early alarm</span>
							</div>
							<div className={styles.ft}>
								<div className={styles.ic}>
									<Heart />
									<Comment />
									<span style={{ marginLeft: "auto", display: "flex" }}>
										<Bookmark />
									</span>
								</div>
								<div className={styles.cm}>
									<b>sarah.travels</b> MADEIRA
								</div>
								<div className={styles.cm}>
									<b>jonas_wanders</b> MADEIRA please!
								</div>
							</div>
						</div>
						<span className={styles.lbl}>
							<b>1</b> · They comment
						</span>
					</div>
					<span className={styles.arr} aria-hidden="true">
						<Chevron />
					</span>
					<div className={styles.stage}>
						<div className={styles.igdm} aria-label="Instagram DM from ilseandreajansen">
							<p className={styles.sys}>
								<b>ilseandreajansen</b> messaged you about a comment you made on their post. <b>See Post</b>
							</p>
							<div className={styles.row}>
								<span className={styles.dav}>
									<img src={img("ilse-avatar.webp")} alt="" className={styles.avatarFill} />
								</span>
								<div className={styles.bub}>
									Here's my Madeira hikes map from the post 🏔️ All 11 hikes, from Pico Ruivo to 25 Fontes. Save it in Stippl and make it yours. Have fun!
									<span className={styles.open}>Open the map</span>
								</div>
							</div>
							<div className={styles.bar}>
								<span className={styles.cam}></span>
								<span>Message...</span>
							</div>
						</div>
						<span className={styles.lbl}>
							<b>2</b> · Your DM
						</span>
					</div>
					<span className={styles.arr} aria-hidden="true">
						<Chevron />
					</span>
					<div className={styles.stage}>
						<div className={`${styles.phoneMini} ${styles.lp} ${saved ? styles.done : ""}`}>
							<img src={img("listpreview-madeira.webp")} alt="Hikes Madeira on stippl.io with a map, 11 places and a Save this guide button" />
							<button type="button" className={styles.savebtn} aria-pressed={saved} onClick={() => setSaved((on) => !on)}>
								<span className={styles.t1}>Save this guide</span>
								<span className={styles.t2}>✓ Saved to Stippl</span>
							</button>
							<span className={styles.tap} aria-hidden="true"></span>
						</div>
						<span className={styles.lbl}>
							<b>3</b> · They save it
						</span>
					</div>
					<span className={styles.arr} aria-hidden="true">
						<Chevron />
					</span>
					<div className={styles.stage}>
						<div className={`${styles.phoneMini} ${styles.app} ${saved ? styles.on : ""}`}>
							<img src={img("app-list.webp")} alt="Hikes Madeira by Ilse as a list in the Stippl app" />
							<span className={styles.toast}>Added to your lists</span>
						</div>
						<span className={styles.lbl}>
							<b>4</b> · It's in their app
						</span>
					</div>
				</div>
			</div>
		</section>
	);
};

export default FlowDemo;
